import { Navigate } from 'react-router-dom';
import { auth } from '../firebase';
import { useEffect, useState } from 'react';

/* This component is used to protect URLs from unauthorized access. It is used in App.js. If you are adding a new page that exists only once
a user is logged in, you must add that page to App.js and wrap it in this component. */


const ProtectedRoute = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const API_BASE_URL = window.location.hostname === 'localhost'
            ? 'http://localhost:5001'
            : 'https://us-central1-joynet-99b18.cloudfunctions.net/app';

        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user && user.emailVerified) {
                const token = await user.getIdToken();
                const response = await fetch(`${API_BASE_URL}/api/verify-token`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    credentials: 'include'
                });
                setIsAuthenticated(response.ok);
            } else {
                setIsAuthenticated(false);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    return isAuthenticated ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;